export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  articleCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'online-learning',
    name: '在线学习资源',
    description: '汇集亚洲优质免费在线学习平台与课程资源，涵盖编程、语言、设计等热门领域',
    icon: 'ri-graduation-cap-line',
    color: 'accent',
    articleCount: 24,
    imageSeq: 'cat-learning-01',
  },
  {
    slug: 'design-tools',
    name: '设计工具资源',
    description: '免费好用的在线设计工具合集，从图形设计到UI设计，高效创作触手可及',
    icon: 'ri-palette-line',
    color: 'primary',
    articleCount: 18,
    imageSeq: 'cat-design-01',
  },
  {
    slug: 'dev-tools',
    name: '开发工具资源',
    description: '开发者必备的免费在线工具，代码编辑器、API测试、数据库管理等一应俱全',
    icon: 'ri-code-s-slash-line',
    color: 'secondary',
    articleCount: 21,
    imageSeq: 'cat-dev-01',
  },
  {
    slug: 'entertainment',
    name: '影视娱乐资源',
    description: '亚洲免费在线影视、动漫、音乐等娱乐资源推荐，轻松享受优质内容',
    icon: 'ri-movie-2-line',
    color: 'accent',
    articleCount: 15,
    imageSeq: 'cat-ent-01',
  },
  {
    slug: 'productivity',
    name: '办公效率工具',
    description: '提升工作效率的免费在线工具，文档协作、项目管理、时间规划一站搞定',
    icon: 'ri-timer-line',
    color: 'primary',
    articleCount: 20,
    imageSeq: 'cat-prod-01',
  },
  {
    slug: 'stock-images',
    name: '图片素材资源',
    description: '高品质免费图片、插画、图标素材网站汇总，商用无风险的优质视觉资源',
    icon: 'ri-image-2-line',
    color: 'secondary',
    articleCount: 16,
    imageSeq: 'cat-img-01',
  },
  {
    slug: 'audio-music',
    name: '音频音乐资源',
    description: '免费的背景音乐、音效、播客资源平台汇总，满足各类音频需求',
    icon: 'ri-music-2-line',
    color: 'accent',
    articleCount: 12,
    imageSeq: 'cat-audio-01',
  },
  {
    slug: 'ai-tools',
    name: 'AI工具资源',
    description: '精选免费AI工具与服务，从智能写作到图像生成，探索人工智能的无限可能',
    icon: 'ri-robot-2-line',
    color: 'primary',
    articleCount: 28,
    imageSeq: 'cat-ai-01',
  },
];